export default "__VITE_ASSET__DW0OXOU___"